import {withAppContext} from "../util/withAppContext";
import EnlilDetail from "./EnlilDetail";
import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography} from "@mui/material";
import spinner from "../assets/Spinner-1s-200px.svg";
import CCButton from "./Common/CCButton";
import css_buttons from "./Common/css/CCButton.module.scss";
import {Google} from "@mui/icons-material";
import {Blue3} from "../theme/styles";
import EnlilAxios from "../util/EnlilAxios";


class EnlilDetailGoogleConfiguration extends EnlilDetail {

    constructor(props) {
        super(props);

        this.state.ConfigurationTested = props.action === "Delete";
        this.state.ConfigurationError = "Unknown";
        this.state.ConfigurationStatus = null;
    }

    inputChangedHandler(event, inputIdentifier) {
        super.inputChangedHandler(event, inputIdentifier);

        this.setState({ConfigurationTested: false, ConfigurationError: "Unknown", ConfigurationStatus: null});
    }

    testConnection() {
        let payload = {
            "ShifamedMessage": {
                "-idoc": "v1.ETLGoogleConfiguration-002",
                "ETLGoogleConfiguration": {
                    "Name": this.applet.getEnterpriseComponent().getAttributeValue("Name"),
                    "ServiceAccountEmail": this.applet.getEnterpriseComponent().getAttributeValue("ServiceAccountEmail"),
                    "PrivateKey": this.applet.getEnterpriseComponent().getAttributeValue("PrivateKey"),
                    "ProjectID": this.applet.getEnterpriseComponent().getAttributeValue("ProjectID"),
                    "Path": this.applet.getEnterpriseComponent().getAttributeValue("Path"),
                }
            }
        }

        EnlilAxios({
            method: "POST",
            url: "t1/v1/etl_google_configurations",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ETLGoogleConfiguration-002",
                "idoc-response": "v1.ETLGoogleConfiguration-002",
            },
        }).then(response => {
            if (response.data.Code === "CC-44RF-KDI4") {
                this.setState({ ConfigurationStatus:  response.data.Message, ConfigurationError: response.data.Code, ConfigurationTested: false }); // Key error
            }
            if (response.data.Code === "CC-0032-HDD4") {
                this.setState({ ConfigurationStatus:  response.data.Message, ConfigurationError: response.data.Code, ConfigurationTested: false }); // Account not found
            }
            if (response.data.Code === "CC-NDJE-SWWE") {
                this.setState({ ConfigurationStatus:  response.data.Message, ConfigurationError: response.data.Code, ConfigurationTested: false }); // Unknown Value Error
            }
            if (response.data.Code === "CC-OODE-DJWE") {
                this.setState({ ConfigurationStatus:  response.data.Message, ConfigurationError: response.data.Code, ConfigurationTested: false }); // Unknown Refresh Error
            }
            if (response.data.Code === "CC-NJJD-DWWZ") {
                this.setState({ ConfigurationStatus:  response.data.Message, ConfigurationError: response.data.Code, ConfigurationTested: true});  // Success
            }
            if (response.data.Code === "CC-DWWW-KD83") {
                this.setState({ ConfigurationStatus:  response.data.Message, ConfigurationError: response.data.Code, ConfigurationTested: false });  // Path not found
            }

        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    }

    renderExtension() {
        let buttonHandler = null;
        let objectDetailContent = null;

        if (this.state.fetchBackgroundOperation === false && this.state.controls !== null && this.state.insertBackgroundOperation === false && this.state.updateBackgroundOperation === false) {
            let content = [];

            let groups = this.getGroups();
            for (let i = 0; i < groups.length; i++) {
                let group = groups[i];

                if (group["type"] === "standard") {
                    content.push(this.renderStandardGroup(group));
                } else if (group["type"] === "checkbox") {
                    content.push(this.renderCheckboxGroup(group));
                }
            }

            let initialModificationWarning = null;
            if (this.state.showInitialModificationWarning === true) {
                initialModificationWarning = (
                    <Grid key="warning" item container spacing={2}>
                        <Typography style={{fontSize: "13px", color: "#E74C3C", marginLeft: "5px", marginTop: "20px"}}>No changes made.</Typography>
                    </Grid>
                );
            }

            if (this.state.insertBackgroundOperation) {}  // force a new render whenever insertBackgroundOperation changes

            objectDetailContent = (
                <React.Fragment>
                    <Grid key="id7" container justifyContent="center" columnSpacing={2}>
                        {content}
                    </Grid>
                    {initialModificationWarning}
                </React.Fragment>
            );

            let firstButtonHandlerContent;
            if (this.state.showConfirmation) {
                firstButtonHandlerContent = (
                    <CCButton
                        className={css_buttons.redStandardButton}
                        onClick={this.cancel2Handler}>
                        Don't Save
                    </CCButton>
                );
            } else if (this.state.action === "Save Completed") {
                firstButtonHandlerContent = (
                    <CCButton
                        className={css_buttons.blueStandardButton}
                        onClick={this.cancel2Handler}>
                        Done
                    </CCButton>
                );
            } else {
                firstButtonHandlerContent = (
                    <CCButton
                        className={css_buttons.redStandardButton}
                        onClick={this.cancel1Handler}>
                        Cancel
                    </CCButton>
                );
            }
            let secondButtonHandlerContent;
            if (this.state.action === "New" || this.state.action === "Edit") {
                secondButtonHandlerContent = (
                    <>
                        {this.props.saveAndNewAction && (
                            <CCButton
                                className={css_buttons.redStandardButton}
                                disabled={this.evaluateSaveDisabledStatus()}
                                animate={this.state.deleteBackgroundOperation === true}
                                onClick={this.saveAndOpenNewHandler}>
                                {this.state.action === "New" ? "+ Add Another" : "+ Add New"}
                            </CCButton>
                        )}
                        <CCButton
                            className={css_buttons.blueStandardButton}
                            disabled={this.evaluateSaveDisabledStatus() || !this.state.ConfigurationTested}
                            animate={this.state.updateBackgroundOperation === true || this.state.insertBackgroundOperation === true}
                            onClick={() => this.saveHandler()}>
                            {this.state.performConfirmOnSave ? "Confirm" : "Save"}
                        </CCButton>
                    </>
                );
            } else if (this.state.action === "Query") {
                secondButtonHandlerContent = (
                    <>
                        <CCButton
                            className={css_buttons.blueStandardButton}
                            disabled={this.evaluateSaveDisabledStatus()}
                            animate={this.state.queryBackgroundOperation === true}
                            onClick={() => this.searchHandler()}>
                            Search
                        </CCButton>
                    </>
                );
            } else if (this.state.action === "Delete") {
                secondButtonHandlerContent = (
                    <>
                        <CCButton
                            className={css_buttons.blueStandardButton}
                            disabled={this.evaluateSaveDisabledStatus()}
                            animate={this.state.deleteBackgroundOperation === true}
                            onClick={() => this.saveHandler()}>
                            Delete
                        </CCButton>
                    </>
                );
            }

            buttonHandler = (
                <DialogActions style={{marginBottom: "10px", width: "96%"}}>
                    {firstButtonHandlerContent}
                    {secondButtonHandlerContent}
                </DialogActions>
            );
        }

        let title;
        if (this.props.title !== null && this.props.title !== undefined) {
            if (this.state.action === "New") {
                title = "Add " + this.props.title;
            } else if (this.state.action === "Delete") {
                title = "Delete " + this.props.title;
            } else if (this.state.action === "Edit") {
                title = "Edit " + this.props.title;
            } else if (this.state.action === "Save") {
                title = "Saving... One moment please.";
            } else if (this.state.action === "Save Completed") {
                title = "Save completed.";
            } else if (this.state.action === "Query") {
                title = "Search " + this.props.title;
            } else {
                title = "View " + this.props.title;
            }
        }

        return (
            <>
                <Dialog open={true} scroll="body">
                    <DialogTitle>
                        <div style={{display: "flex", flexDirection: "row"}}>
                            <Google sx={{color: Blue3, width: "55px", height: "55px"}}/>
                            <Typography style={{marginLeft: "10px", marginTop: "12px", fontSize: "20px", fontWeight: "500"}}>{title}</Typography>
                        </div>
                    </DialogTitle>
                    <DialogContent style={{height: "350px"}}>
                        <>
                            {objectDetailContent || (
                                <div style={{display: "flex", justifyContent: "center", marginBottom: "10px"}}>
                                    <img src={spinner} alt="spinner" width={80} height={80} style={{margin: "auto"}} />
                                </div>
                            )}
                        </>
                    </DialogContent>
                    {!this.state.ConfigurationTested ? (
                        <>
                            <div style={{marginTop: "40px", marginLeft: "20px", marginRight: "20px", marginBottom: "20px"}}>
                                <Button
                                    className={css_buttons.blueStandardButton}
                                        style={{marginTop: "10px", width: "100%"}}
                                        fullWidth
                                        disabled={!this.isFormValid()}
                                        onClick={() => {
                                            this.testConnection()
                                        }}
                                    >
                                        <span>Test Connection</span>
                                </Button>
                            </div>
                            <div style={{marginLeft: "20px", marginRight: "20px", marginBottom: "20px"}}>
                                <Typography style={{marginLeft: "10px", marginTop: "12px", color: "#FF0000", fontSize: "16px", fontWeight: "500"}}>{this.state.ConfigurationStatus}</Typography>
                            </div>
                        </>
                    ) : null}
                    {this.state.ConfigurationTested && this.props.action !== "Delete" ? (
                        <div style={{marginLeft: "20px", marginRight: "20px", marginBottom: "20px"}}>
                            <Typography style={{marginLeft: "10px", marginTop: "12px", color: "#00FF00", fontSize: "16px", fontWeight: "500"}}>Success! </Typography>
                        </div>
                    ) : null}

                    {buttonHandler}

                </Dialog>
            </>
        );
    }
}

export default withAppContext(EnlilDetailGoogleConfiguration);